import { render } from "./InputLabel.vue?vue&type=template&id=9105608a"
import script from "./InputLabel.vue?vue&type=script&lang=js"
export * from "./InputLabel.vue?vue&type=script&lang=js"

import "./InputLabel.vue?vue&type=style&index=0&id=9105608a&lang=postcss"
script.render = render

export default script